import React from 'react'
import { convertDateStringIntoDateObject, convertStringToUTCString, createEventObjectForDayView } from '../calendarFunctions'
import InternalCalendarMenu from '../InternalCalendarMenu/InternalCalendarMenu'
import SmallDayViewCalendar from './DayViewComponents/SmallDayViewCalendar'
import DayViewHorizontalLines from './DayViewComponents/DayViewHorizontalLines'
import DayViewEventChip from './DayViewComponents/DayViewEventChip'
import DayViewMiniSideCalendar from './DayViewComponents/DayViewMiniSideCalendar'
import { addMinutes, format } from 'date-fns'
import CreateNewEventEmptyGridBoxDayView from '../WeekViewCalendar/CreateNewEventEmptyGridBoxDayView'
import DayViewAvailabilityPlaceholderChip from './DayViewComponents/DayViewAvailabilityPlaceholderChip'

const DayViewCalendar = (props) => {
  const container = React.useRef(null)
  const containerNav = React.useRef(null)
  const containerOffset = React.useRef(null)

  const [internalSelectedDay, setInternalSelectedDay] = React.useState(props.selectedDay)
  const [finalDateObject, setFinalDateObject] = React.useState(props.selectedDay)
  const [numberOfColumns, setNumberOfColumns] = React.useState(1)

  React.useEffect(() => {
    // Set the container scroll position based on the current time.
    const currentMinute = new Date().getHours() * 60
    container.current.scrollTop =
      ((container.current.scrollHeight - containerNav.current.offsetHeight - containerOffset.current.offsetHeight) *
        currentMinute) /
      1440
  }, [])

  React.useEffect(() => createEventObjectForDayView(props.calendarDaysWithEvents, props.selectedDay, setInternalSelectedDay), [props.selectedDay, props.calendarDaysWithEvents])

  React.useEffect(() => createColumns(), [internalSelectedDay])

  const createColumns = () => {
    let tempDay = internalSelectedDay
    let columns = 1
    let hash = {}
    for(let i = 0; i < tempDay.events.length; i++) {
      let event = tempDay.events[i]
      let time = new Date(event.dateTime).getTime()
      if(hash[time]) {
        hash[time] = hash[time] + 1
        hash[time] > columns ? columns = hash[time] : columns = columns
        event.column = columns
      } else {
          hash[new Date(event.dateTime).getTime()] = 1
          event.column = 1
        }
    }
    setFinalDateObject({...tempDay})
    setNumberOfColumns(columns)
  }

  const createNewEventByClickBlankSpace = (col, i) => {
    let correctDateFormat = typeof props.selectedDay.date === 'string' ? convertDateStringIntoDateObject(props.selectedDay.date) : props.selectedDay.date
    let formattedDateTime = format(addMinutes(correctDateFormat, (i - 2) * 5), "yyyy-MM-dd'T'HH:mm:ss") 
    props.createNewCalendarEvent(convertStringToUTCString(formattedDateTime, props.schoolCalendar.timeZone))
  }

  return (
    <div className={`h-[720px] ${(props.editEventToggle || props.newEvent || props.newOfferObject || props.openOffer) && 'w-[820px]'} my-4 mx-1`}>
        <div className="flex h-full flex-col rounded-xl overflow-hidden">
          <InternalCalendarMenu view={'Day view'} setView={props.setView} selectedDay={props.selectedDay} setSelectedDay={props.setSelectedDay} calendarDaysWithEvents={props.calendarDaysWithEvents} currentMonth={props.currentMonth} setCurrentMonth={props.setCurrentMonth} />
          <div className="isolate flex flex-auto overflow-hidden mt-4 border border-solid border-gray-200 rounded-t-2xl">
            <div ref={container} className="flex flex-auto flex-col overflow-y-auto overflow-x-hidden">
              <SmallDayViewCalendar containerNav={containerNav} />
              <div className="flex flex-auto">
                <div className="w-14 flex-none bg-white ring-1 ring-gray-100" />
                <div className="grid flex-auto grid-cols-1 grid-rows-1 mt-2">
                  <DayViewHorizontalLines containerOffset={containerOffset} />
                  <ol className={`col-start-1 col-end-2 row-start-1 grid grid-cols-${numberOfColumns} mb-0 mt-0`} style={{ gridTemplateRows: '1.75rem repeat(288, minmax(0, 1fr)) auto' }}>
                    {Array.from(Array(288), (e, i) => (
                      <CreateNewEventEmptyGridBoxDayView key={i} i={i} numberOfColumns={numberOfColumns} createNewEventByClickBlankSpace={createNewEventByClickBlankSpace} />
                    ))}
                    {finalDateObject.events.map((event) => 
                    event.isAvailabilityPlaceholder ?
                      <DayViewAvailabilityPlaceholderChip key={event.id} event={event} />
                    :
                    <DayViewEventChip key={event.id} event={event} setEditEvent={props.setEditEvent} setEventToEdit={props.setEventToEdit} />)}
                  </ol>
                </div>
              </div>
            </div>
            <DayViewMiniSideCalendar selectedDay={props.selectedDay} calendarDaysWithEvents={props.calendarDaysWithEvents} setSelectedDay={props.setSelectedDay} currentMonth={props.currentMonth} setCurrentMonth={props.setCurrentMonth} />
          </div>
        </div>
    </div>
  )
}

export default DayViewCalendar;
